import React from 'react'
import MaterialCodePage from './MaterialCodePage'
import '../styles/index.scss'

const MaterialCodeContainer = () => {
    return (
        <MaterialCodePage />
    )
}

export default MaterialCodeContainer